import { Entity } from './common.types';
import { Filter } from '@ecosystem/newron-client-lib';

export type FiltersValues = Record<string, Entity[]>;

export enum FilterType {
  multiSelect = 'multiSelect',
  numericRange = 'numericRange',
  dateRange = 'dateRange',
  select = 'select',
}

export type FiltersGrouped = {
  code: string;
  label: string;
  definitions: FilterDefinition[];
};

export type FiltersUngrouped = {
  definitions: FilterDefinition[];
};

export type FilterDefinition = {
  name: string;
  label: string;
  type: FilterType;
  placeholder?: string;
  options?: Entity[];
  min?: number;
  max?: number;
  roundTo?: number;
  currency?: string;
  value?: string;
  hierarchy?: {
    enabled: boolean;
    level?: string;
    name?: string;
    parent?: string;
  };
};

export type FilterSections = {
  label: string;
  maxFeatureLimit?: number;
  grouped?: FiltersGrouped[];
  ungrouped?: FiltersUngrouped;
  isMain?: boolean;
};

export type Filters = {
  sections: FilterSections[];
  values: FiltersValues;
};

export interface SavedFilterData {
  values: FiltersValues;
  definitionLabels: Entity[];
}

export interface SavedFilter extends Filter {
  data: SavedFilterData;
}
